import{STORAGE_UTILITIES as o}from"../storage/storage.js";var e,r=o("undefined"==typeof window?{}:null===(e=window)||void 0===e?void 0:e.localStorage);export{r as LOCAL_STORAGE};
